import { render, staticRenderFns } from "./comprobar.vue?vue&type=template&id=66ef419f"
import script from "./comprobar.vue?vue&type=script&lang=js"
export * from "./comprobar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports